<template>
  <v-container
    fluid
    :class="{
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode,
      isBlocked: !editMode,
    }"
  >
    <v-layout row wrap>
      <v-flex xs12 owners>
        <v-layout row wrap v-if="!bankData || !bankData.length">
          <v-flex xs12>
            <h2 class="empty_title">
              {{ $t("components.clients.bank.emptyTitle") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12>
            <table v-if="bankData.length">
              <tr class="table__captions">
                <th>{{ $t("components.clients.bank.table.name") }}</th>
                <th>{{ $t("components.clients.bank.table.bik") }}</th>
                <th>{{ $t("components.clients.bank.table.account") }}</th>
                <th></th>
              </tr>
              <tr v-for="(item, idx) in bankData" :key="idx">
                <td @click="editBank(item)" class="item-name">
                  <strong>{{ item.name }}</strong>
                  ({{ item.settlement_account.substr(-4) }})
                </td>
                <td>{{ item.bik }}</td>
                <td>{{ item.settlement_account }}</td>

                <td class="table-actions">
                  <div class="table-actions__buttons text-right">
                    <v-btn
                      text
                      icon
                      @click="editBank(item)"
                      :disabled="!editMode"
                      class="ma-0 pa-0"
                    >
                      <v-icon color="warning" size="20px">edit</v-icon>
                    </v-btn>

                    <delete-dialog
                      :deleteButton="{
                        type: 'icon',
                        value: 'delete',
                        disabled: !editMode,
                      }"
                      :item-name="item.name"
                      v-on:deleteEntry="deleteEntry(item)"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
        <span @click="createNewBank" class="add-link" v-if="editMode">
          <v-icon>add</v-icon>{{ $t("components.clients.bank.addBank") }}
        </span>
      </v-flex>

      <v-dialog
        v-model="createBank"
        transition="slide-x-reverse-transition"
        content-class="halfscreen"
        persistent
      >
        <add-bank
          v-on:updateBanks="updateBanks"
          v-on:addBanks="addBanks"
          v-on:closeModal="closeModal"
          :editedBank="bank"
          :create="create"
          :editMode="editMode"
          :packageMode="packageMode"
          :publicHash="publicHash"
          :agentMode="agentMode"
          :accounts-total="bankData.length"
        />
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import AddBank from "@/components/clients/add/bank";
import { apiCallTrue } from "@/utils/api";
import DeleteDialog from "@/components/lib/DeleteDialog";

export default {
  name: "ClientBank",
  data: () => ({
    createBank: false,
    create: null,
    bank: {},
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    bankData: {
      type: Array,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AddBank,
    DeleteDialog,
  },
  methods: {
    updateBanks(bank) {
      this.$emit("updateBanks", bank);
      this.createBank = false;
      this.bank = {};
      this.create = null;
    },
    addBanks(bank) {
      this.$emit("addBanks", bank);
      this.createBank = false;
      this.bank = {};
      this.create = null;
    },
    closeModal() {
      this.createBank = false;
      setTimeout(() => (this.create = null), 1000);
    },
    editBank(bank) {
      this.create = false;
      this.bank = Object.assign({}, bank);
      this.createBank = true;
    },
    async deleteEntry(item) {
      const index = this.bankData.indexOf(item);
      const url = this.publicHash
        ? `v1/bank-accounts/${item.id}/delete-by-hash/${this.publicHash}`
        : `v1/bank-accounts/${item.id}/delete`;

      if (this.packageMode && !this.publicHash) {
        this.bankData.splice(index, 1);
      } else {
        await apiCallTrue({
          url,
          method: "POST",
        })
          .then(() => {
            this.bankData.splice(index, 1);
          })
          .catch(() => console.log("not deleted"));
      }
    },
    createNewBank() {
      this.create = true;
      this.createBank = true;
    },
  },
};
</script>

<style scoped>
#app .v-menu__content {
  box-shadow: 0 0 0;
}
</style>
